import { render } from "./ContractPaymentsChart.vue?vue&type=template&id=0425c0f4"
import script from "./ContractPaymentsChart.vue?vue&type=script&lang=js"
export * from "./ContractPaymentsChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__